var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screen"},[_c('div',{staticClass:"screen__header"},[_vm._t("header")],2),_c('div',{staticClass:"screen__content"},[_vm._t("library"),_vm._t("editor",[_c('Editor')]),_vm._t("setting")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }